import script from "./OrderHold.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderHold.vue?vue&type=script&setup=true&lang=ts"

import "./OrderHold.vue?vue&type=style&index=0&id=f58515f8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58515f8"]])

export default __exports__